import {useLazyQuery} from '@apollo/client'
import {GETCLIENTFEATUREFLAGS} from '../../../../../utils/GraphQLAPI'
import {useEffect} from 'react'
import globalUiTexts from '../../../../../utils/GlobalUITexts.json'
const Settings = ({formik, isEdit = false, editDisabled}: any) => {
  const [getClientFeatureFlags, {data: featureFlags}] = useLazyQuery(GETCLIENTFEATUREFLAGS, {
    fetchPolicy: 'network-only',
  })
  useEffect(() => {
    getClientFeatureFlags()
  }, [])
  console.log('Fomeik in settings', formik.values)
  return (
    <div className='pb-5' data-kt-stepper-element='content'>
      <div className={`w-100  ${!isEdit ? 'h-300px' : ''} flex-wrap ${isEdit && 'd-flex'}`}>
        <div className={`form-check form-check-custom form-check-solid mt-7 ${isEdit && 'me-5'}`}>
          <input
            className='form-check-input me-2'
            type='checkbox'
            checked={formik.values.ivr}
            name='ivr'
            onChange={(e) => {
              formik.setFieldValue('ivr', !formik.values.ivr)
            }}
            disabled={editDisabled}
            id='ivr'
          />
          <label className='form-check-label fs-5' htmlFor='ivr'>
            Enable IVR
          </label>
        </div>
        {featureFlags?.getClientFeatureFlags?.enableLiveAgent && (
          <div className={`form-check form-check-custom form-check-solid mt-7 ${isEdit && 'me-5'}`}>
            <input
              className='form-check-input me-2'
              type='checkbox'
              checked={formik.values.liveAgent}
              name='liveagent'
              onChange={(e) => {
                formik.setFieldValue('liveAgent', !formik.values.liveAgent)
              }}
              id='liveagent'
              disabled={editDisabled}
            />
            <label className='form-check-label fs-5' htmlFor='liveagent'>
              Enable Live Agent
            </label>
          </div>
        )}
        {featureFlags?.getClientFeatureFlags?.enableTextTpv && (
          <div className={`form-check form-check-custom form-check-solid mt-7 ${isEdit && 'me-5'}`}>
            <input
              className='form-check-input me-2'
              name='texttpv'
              type='checkbox'
              {...formik.getFieldProps('textTpv')}
              onChange={(e) => {
                formik.setFieldValue('textTpv', e.target.checked)
              }}
              checked={formik.values.textTpv}
              id='texttpv'
              disabled={editDisabled}
            />
            <label className='form-check-label fs-5' htmlFor='texttpv'>
              Enable Text TPV
            </label>
          </div>
        )}
        {featureFlags?.getClientFeatureFlags?.enableSmsDocumentVerification && (
          <div className={`form-check form-check-custom form-check-solid mt-7 ${isEdit && 'me-5'}`}>
            <input
              className='form-check-input me-2'
              type='checkbox'
              name='smsd2d'
              {...formik.getFieldProps('smsD2D')}
              onChange={(e) => {
                formik.setFieldValue('smsD2D', e.target.checked)
              }}
              checked={formik.values.smsD2D}
              id='smsd2d'
              disabled={editDisabled}
            />
            <label className='form-check-label fs-5' htmlFor='smsd2d'>
              {globalUiTexts.FEATURE_FLAGS_UI.smsD2D}
            </label>
          </div>
        )}
        {featureFlags?.getClientFeatureFlags?.enableEmailDocumentVerification && (
          <div className={`form-check form-check-custom form-check-solid mt-7 ${isEdit && 'me-5'}`}>
            <input
              className='form-check-input me-2'
              type='checkbox'
              name='emaild2d'
              {...formik.getFieldProps('emailD2D')}
              onChange={(e) => {
                formik.setFieldValue('emailD2D', e.target.checked)
              }}
              checked={formik.values.emailD2D}
              id='emaild2d'
              disabled={editDisabled}
            />
            <label className='form-check-label fs-5' htmlFor='emaild2d'>
              {globalUiTexts.FEATURE_FLAGS_UI.emailD2D}
            </label>
          </div>
        )}
        {featureFlags?.getClientFeatureFlags?.enableOutBoundLiveAgent && (
          <div className={`form-check form-check-custom form-check-solid mt-7 ${isEdit && 'me-5'}`}>
            <input
              className='form-check-input me-2'
              type='checkbox'
              name='outboundliveagent'
              {...formik.getFieldProps('outboundLiveAgent')}
              onChange={(e) => {
                formik.setFieldValue('outboundLiveAgent', e.target.checked)
              }}
              checked={formik.values.outboundLiveAgent}
              id='outboundliveagent'
              disabled={editDisabled}
            />
            <label className='form-check-label fs-5' htmlFor='outboundliveagent'>
              Enable {globalUiTexts.FEATURE_FLAGS_UI.outboundLiveAgent}
            </label>
          </div>
        )}
      </div>
    </div>
  )
}
export default Settings
